<template>
  <div class="app-container">
    <div class="title-container">
      <div>评论回复列表</div>
    </div>
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="用户昵称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in statusArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <!-- <DataPicker
        @valueFunc="getPickerValueFunc"
        startPlaceholder="评论开始时间"
        endPlaceholder="评论截止时间"
      /> -->
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" @click="handleReset">重置</el-button>
      <el-button class="filter-item" type="primary" @click="showAddReplyDialog"
        >新增评论回复</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="订单ID"></el-table-column>
      <el-table-column align="center" prop="userName" label="用户昵称"></el-table-column>

      <el-table-column align="center" prop="userId" label="用户ID"></el-table-column>
      <el-table-column label="所属评价ID" align="center" prop="reviewId"></el-table-column>
      <el-table-column label="父回复ID" align="center" prop="parentReplyId"></el-table-column>
      <el-table-column class-name="status-col" label="状态" prop="status" align="center">
        <template slot-scope="scope">
          <el-tag :color="getValue(ORDER_STATUS_CSS, scope.row.status)" style="color: #FFFFFF">
            {{ statusArr.find(item => item.value === scope.row.status)?.label || "-" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="回复内容" prop="content" align="center">
      </el-table-column>
      <el-table-column align="center" label="创建时间" prop="ctdate">
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.ctdate" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间" prop="mddate">
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.mddate" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="操作"
        align="center"
        width="120"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleDelete(scope.row)"
            plain
            class="comm_but_warp"
            >删除</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <AddReply :reviewList="list" :visible.sync="addReplyVisible" @success="handleAddReplySuccess" />

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getAdminReviewRepliesList, deleteReview } from "@/api/goodsReview";
import { formatApiDate } from "@/utils/utils";
import { getValue } from "@/utils/enumUtile";
import { ORDER_STATUS_CSS } from "@/utils/enumUtileCss";
import DataPicker from "@/views/components/dataPicker.vue";
import AddReply from "./components/addReply.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_STATUS_CSS() {
      return ORDER_STATUS_CSS;
    }
  },
  components: { DataPicker, AddReply },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        name: null,
        goodsName: null,
        status: null
      },
      shipmentsVisible: false,
      orderInfo: {},
      shipmentsBtnLoading: false,
      auditRemark: "",
      goodsList: [],
      goodsListLoading: false,
      addReplyVisible: false,
      addOrderReviewVisible: false,
      statusArr: [
        {
          label: "待审核",
          value: 0
        },
        {
          label: "已通过",
          value: 1
        },
        {
          label: "已拒绝",
          value: 2
        },
        {
          label: "已隐藏",
          value: 3
        }
      ]
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleDelete(item) {
      this.$confirm("确认删除该条评论吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteReview({ Id: item.id }).then(resp => {
          if (resp && resp.bizcode === 100) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: resp.msg || "删除失败"
            });
          }
        });
      });
    },
    showAddReplyDialog() {
      this.addReplyVisible = true;
    },
    handleAddReplySuccess() {
      this.getList();
    },

    handleAddOrderReviewSuccess() {
      this.getList();
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        name: null,
        goodsName: null,
        status: null
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getAdminReviewRepliesList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(value) {
      this.listQuery.startTime = value[0];
      this.listQuery.endTime = value[1];
    }
  }
};
</script>
<style scoped lang="scss">
.title-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;

  p {
    font-size: 14px;
    color: #909399;
    margin-top: 5px;
    font-weight: normal;
  }
}

.comm_but_warp {
  margin-bottom: 10px;
}

.filter-container {
  display: flex;
  /* 使用 flex 布局 */
  flex-wrap: wrap;
  /* 允许内容换行 */
  align-items: center;
  /* 垂直居中对齐 */
  gap: 10px;
  /* 元素之间的间距（现代浏览器支持） */
  margin-bottom: 20px;
  flex-direction: row;

  // 针对 filter-item 的统一样式
  .filter-item {
    margin-bottom: 0 !important;
    /* 清除默认的底部边距，由 gap 或容器控制 */
    flex-shrink: 0;
    /* 禁止压缩内容长度 */
  }
}

.comm_but_warp {
  margin-bottom: 5px;
}

.card_content {
  display: flex;
  flex-direction: column;
}
</style>
